import { createContext } from "react";

export interface CurrentUser {
  id: string;
  display_name: string;
  email: string;
}

export interface CurrentUserContextValue {
  user: CurrentUser | null;
  logout: () => Promise<void>;
  loading: boolean;
  loggingOut: boolean;
}

export const CurrentUserContext = createContext<CurrentUserContextValue>({
  user: null,
  logout: async () => {},
  loading: true,
  loggingOut: false,
});
